<div class="message_popup__content ion-padding-start ion-padding-end" [innerHTML]="text"></div>
